<template>
  <div class="background-image" :style="computedStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BackgroundImage",
  props: {
    src: String,
    styles: String
  },
  computed: {
    computedStyle() {
      return `background-image: url(${this.src});` + this.styles;
    }
  }
};
</script>

<style scoped>
.background-image {
  width: 100%;
  height: auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>
